import { render } from "./Policy.vue?vue&type=template&id=effe670a&scoped=true"
import script from "./Policy.vue?vue&type=script&lang=js"
export * from "./Policy.vue?vue&type=script&lang=js"

import "./Policy.vue?vue&type=style&index=0&id=effe670a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-effe670a"

export default script